<template>
  <div style="margin-top: 10px">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-center">{{Title}}</h2>
        <base-input v-model="dataModel.Text" @blur="change"></base-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Title: {
      type: String,
      default: "",
      description: "",
    },
    MissingItemEntityID: {
      type: Number,
      default: 0,
      description: "",
    },
  },
  data() {
    return {
      dataModel: { Text: "" },
      Validate: true,
      JSONValue: "",
      Errors: [],
    };
  },
  methods: {
    change(element) {
      this.validate();
      this.JSONValue = JSON.stringify(this.dataModel);
      this.$emit("saveValue", {
        MissingItemEntityID: this.MissingItemEntityID,
        JSON: this.JSONValue,
      });
    },
    validate() {
      var _context = this;
      _context.Errors = [];

      if (_context.dataModel.Text.length == 0) {
        _context.Errors.push("Debe ingresar un valor en " + _context.Title);
      }
      _context.emitErrors(_context);
    },
    emitErrors(_context) {
      this.$emit("setErrors", _context.Errors);
    },
  },
};
</script>